export const SubscriptionType = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
};

export const SubscriptionStatus = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  PENDING: 'pending',
};

export const SubscriptionCategory = {
  STREAMING: 'streaming',
  SOFTWARE: 'software',
  GAMING: 'gaming',
  MUSIC: 'music',
  FITNESS: 'fitness',
  OTHER: 'other',
};

export const FeedbackCategory = {
    UI: 'UI',
    FEATURE: 'FEATURE',
    BUG: 'BUG',
    PERFORMANCE: 'PERFORMANCE',
    OTHER: 'OTHER'
};

export const FeedbackSentiment = {
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE'
}; 